/* eslint-disable no-alert */
import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import Paper from '@mui/material/Paper'
import {
  Box,
  Divider,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material'
import Button from '@mui/material/Button'
import { useFormik } from 'formik'

import axios from 'src/utilities/http-client'
import theme from 'src/theme'
import validationSchema from './validators/register.validators'

let BoundTreeTrialRegister: FunctionComponent = () => {
  let isTablet = useMediaQuery(theme.breakpoints.down('md'))
  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))

  let navigate = useNavigate()
  let form = useFormik({
    validationSchema,
    initialValues: {
      email: '',
    },
    onSubmit: async (values) => {
      await axios
        .post('/api/register-with-boundtree', {
          email: values.email.trim(),
          accessLevel: 'boundTreeLimited',
        })
        .then(() => {
          window.alert(
            'Submission successful! Please check your email to complete your registration.',
          )
          navigate('/')
        })
        .catch(() => window.alert('Email already exists.'))
    },
  })

  return (
    <Box
      component="main"
      className="relative h-screen"
      style={{
        background:
          'linear-gradient(to left, rgba(66, 165, 245,0.4), rgba(66, 165, 245,0)) 55%, url(/banner.png)',
        backgroundSize: '25% 100%, cover',
        backgroundPosition: 'right center, center center',
        backgroundRepeat: 'no-repeat, no-repeat',
        marginTop: -60,
      }}
    >
      <Box className="flex justify-center mt-5" style={{ paddingTop: 60 }}>
        <Typography
          component="h1"
          sx={{ fontFamily: 'smileAndWave' }}
          variant="h4"
        >
          Let's get started with your free trial!
        </Typography>
      </Box>
      <Box className="mx-5">
        <Box className="flex flex-row">
          <Box className="hidden md:flex">
            <Box
              className="relative flex w-2/5 justify-center"
              style={{
                background: 'url(/btlogo.png)',
                backgroundPosition: '0px 48%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
              }}
            />
          </Box>

          <Paper
            className={`m-4 p-4 ${
              isTablet ? `${isPhone ? 'w-full' : 'w-3/4'} mx-auto` : 'w-1/2'
            }`}
          >
            <Typography>
              Please register for a limited-access free trial of FOAMfrat Studio
              account to use our app and access your certificates and profile.
              Contact us at any time to upgrade.
            </Typography>
            <form onSubmit={form.handleSubmit}>
              <Box className={`flex ${isPhone ? 'flex-col' : 'flex-row'}`}>
                <TextField
                  fullWidth
                  variant="standard"
                  className="mx-4"
                  label="Email"
                  name="email"
                  type="text"
                  onChange={form.handleChange}
                  error={form.touched.email && !!form.errors.email}
                  helperText={form.touched.email && form.errors.email}
                />
              </Box>

              <Box className="flex justify-end">
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className="my-6 mr-6"
                >
                  Submit
                </Button>
              </Box>
            </form>
            <Divider className="my-8" />
            <Typography>
              By clicking submit you agree to our Privacy Policy and Terms and
              Conditions linked below.
            </Typography>
            <Box
              className={`flex ${
                isPhone ? 'flex-col' : 'flex-row justify-center'
              }`}
            >
              <Button
                variant="contained"
                color="primary"
                className="mt-8 mx-2"
                href="https://www.foamfrat.com/privacy-policy"
                target="_blank"
              >
                Privacy Policy
              </Button>
              <Button
                variant="contained"
                color="primary"
                className="mt-8 mx-2"
                href="https://www.foamfrat.com/termsofservice"
                target="_blank"
              >
                Terms & Conditions
              </Button>
            </Box>
          </Paper>
        </Box>
      </Box>
    </Box>
  )
}

export default BoundTreeTrialRegister
